import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import LatexKeypadButton from './LatexKeypadButton';
import KeypadButton from './KeypadButton';

class BasicMath extends Component {
  render() {
    return (
      <Keypad className="basic-math" {...this.props}>
        <div>
          {/* Symbols */}
          <LatexKeypadButton label="x" />
          <LatexKeypadButton label="x^2" value="^2" />
          <LatexKeypadButton label="x^{}" />
          <LatexKeypadButton label="x_{}" />
          <LatexKeypadButton label="\sqrt{}" />
          {/* Fractions */}
          <LatexKeypadButton label="\frac{}{}" />
          <LatexKeypadButton label="x\frac{}{}" />
        </div>
        <div>
          <LatexKeypadButton label="y" />
          {}
          <LatexKeypadButton label="({})" />
          <LatexKeypadButton label="[{}]" />
          <LatexKeypadButton label="|{}|" />
          {/* Symbols */}
          <KeypadButton label="&plusmn;" />
          <LatexKeypadButton label="\sqrt[]{}" />
          <KeypadButton label="%" />
        </div>
        <div>
          {/* Symbols */}
          <KeypadButton label="&lt;" />
          <KeypadButton label="&gt;" />
          <KeypadButton label="&ge;" />
          <KeypadButton label="&le;" />
          <KeypadButton label="&#8776;" />
          <KeypadButton label="&ne;" />
          <KeypadButton label="&#36;" />
        </div>
        <div>
          {/* Geometry & Trigonometry */}
          <KeypadButton label="&pi;" />
          <KeypadButton label="log" />
          <KeypadButton label="cos" />
          <KeypadButton label="sin" />
          <KeypadButton label="tan" />
        </div>
      </Keypad>
    );
  }
}

export default BasicMath;
